var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status === false)?_c('div',{staticClass:"poster-poster"},[_vm._m(0),_c('div',{staticClass:"poster"},[_c('img',{attrs:{"src":_vm.image}})])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('span',{staticClass:"iconfont icon-shuoming"}),_vm._v("提示：长按图片保存至手机相册\n  ")])
}]

export { render, staticRenderFns }